// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as SessionsType$OrcaPaymentPage from "../Types/SessionsType.bs.js";
import * as PaymentMethodsRecord$OrcaPaymentPage from "./PaymentMethodsRecord.bs.js";

function usePaymentMethodExperience(paymentMethodListValue, sessionObj) {
  var klarnaPaymentMethodExperience = React.useMemo((function () {
          return PaymentMethodsRecord$OrcaPaymentPage.getPaymentExperienceTypeFromPML(paymentMethodListValue, "pay_later", "klarna");
        }), [paymentMethodListValue]);
  var klarnaTokenObj = React.useMemo((function () {
          return SessionsType$OrcaPaymentPage.getPaymentSessionObj(sessionObj.sessionsToken, "Klarna");
        }), [sessionObj]);
  var isKlarnaSDKFlow = klarnaPaymentMethodExperience.includes("InvokeSDK");
  var isKlarnaCheckoutFlow = klarnaPaymentMethodExperience.includes("RedirectToURL");
  return {
          klarnaTokenObj: klarnaTokenObj,
          isKlarnaSDKFlow: isKlarnaSDKFlow,
          isKlarnaCheckoutFlow: isKlarnaCheckoutFlow
        };
}

export {
  usePaymentMethodExperience ,
}
/* react Not a pure module */
